import { Modal, Spin, Row, Col, Button } from "antd";
import React from "react";
import { strings } from "../../../helpers";

export default class ShowImageResultModal extends React.Component {
  render() {
    const {
      attachmentImageData,
      openImageResultModal,
      cancelImageResultModal
    } = this.props;
    return (
      <Modal
        title={`${strings.ticket_detail_view.MedicalLicense}`}
        wrapClassName="vertical-center-modal carousal-modal"
        visible={openImageResultModal}
        width={900}
        onCancel={cancelImageResultModal}
        footer={null}
        destroyOnClose
      >
        <div>
          <Row>
            <Col span={24}>
              <div className="modal-image-wrapper">
                <img src={`${attachmentImageData}`} alt="..." />
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}
